// The API's codes that confirm an announcement's creation or edit on the socket; never shown to the author.
export const ANNOUNCEMENT_CREATED = "SUCCESSFULLY_CREATED_ANNOUNCEMENTS"
export const ANNOUNCEMENT_UPDATED = "SUCCESSFULLY_UPDATED_ANNOUNCEMENTS"

export const getKnownAnnouncementIds = announcements =>
  new Set(
    (Array.isArray(announcements) ? announcements : [])
      .map(announcement => announcement?._id)
      .filter(Boolean)
  )

// The narrow announcements read proves that the submitted announcement was
// persisted: a row that did not exist when the form was submitted and carries
// the submitted title.
export const hasPersistedAnnouncement = (
  announcements,
  { knownAnnouncementIds, title }
) =>
  Array.isArray(announcements) &&
  announcements.some(
    announcement =>
      Boolean(announcement?._id) &&
      !knownAnnouncementIds.has(announcement._id) &&
      announcement?.title === title
  )
